import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { FrequentQuestionComponent } from '../../../../shared/components/frequent-question/frequent-question.component';
import { FaqDto } from '../../../../../api/client';

@Component({
  selector: 'app-frequent-question-list',
  imports: [FrequentQuestionComponent],
  standalone: true,
  templateUrl: './frequent-question-list.component.html',
  styleUrl: './frequent-question-list.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FrequentQuestionListComponent {
  @Input() questions: FaqDto[] = [];
}
